(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["superfoot-surface-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-sf-surface-link]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = new URL(link.href);
    target.search = window.location.search;
    target.searchParams.delete('page');
    event.preventDefault();
    window.location.assign(target.href);
  });
  } catch(e) { console.error(e); }
})();

})();
